import React, { useRef } from 'react';
import { Button, Select, Space } from 'antd';
import type { RefSelectProps } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { timeSlotOptions } from '../utils/timeUtils';

// ドロップダウンを開いたとき、既定でスクロールしておきたい時刻
const DEFAULT_SCROLL_TIME = '9:00';

interface ClearableTimeSelectProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder: string;
  onClear: () => void;
  style?: React.CSSProperties;
}

const ClearableTimeSelect: React.FC<ClearableTimeSelectProps> = ({
  value,
  onChange,
  placeholder,
  onClear,
  style,
}) => {
  const selectRef = useRef<RefSelectProps>(null);

  // 未選択時は、開いた瞬間にリスト先頭（0:00）ではなく9:00が上に来る位置までスクロールしておく
  // （選択済みの場合はantd標準の「選択中の項目までスクロール」に任せる）
  const handleOpenChange = (open: boolean) => {
    if (!open || value) return;
    const idx = timeSlotOptions.findIndex(opt => opt.value === DEFAULT_SCROLL_TIME);
    if (idx === -1) return;
    setTimeout(() => {
      selectRef.current?.scrollTo({ index: idx, align: 'top' });
    }, 0);
  };

  return (
    <Space.Compact style={{ width: '100%', ...style }}>
      <Select
        ref={selectRef}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onDropdownVisibleChange={handleOpenChange}
        style={{ width: '100%' }}
      >
        {timeSlotOptions.map(opt => (
          <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
        ))}
      </Select>
      <Button
        icon={<CloseCircleFilled style={{ color: '#bfbfbf' }} />}
        size="small"
        style={{ flexShrink: 0, padding: '0 4px', border: '1px solid #e0e0e0', boxShadow: 'none', background: '#f5f5f5' }}
        title="クリア"
        onClick={onClear}
      />
    </Space.Compact>
  );
};

export default ClearableTimeSelect;
